import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { UtmStorage, UtmFields } from "@/shared/lib/classes/UtmStorage";

/**
 * Hook to manage UTM fields from URL and localStorage
 * Automatically captures UTM parameters from URL on mount and stores them
 *
 * @returns Object containing utmFields and methods to manage them
 */
export function useUtmFields() {
  const { search } = useLocation();

  // Capture UTM fields from URL on mount or when search params change
  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    UtmStorage.captureFromUrl(searchParams);
  }, [search]);

  /**
   * Get current UTM fields from storage
   */
  const getUtmFields = (): UtmFields | null => {
    return UtmStorage.get();
  };

  /**
   * Set UTM fields manually
   */
  const setUtmFields = (fields: UtmFields): void => {
    UtmStorage.set(fields);
  };

  /**
   * Clear UTM fields
   */
  const clearUtmFields = (): void => {
    UtmStorage.clear();
  };

  /**
   * Check if UTM fields exist
   */
  const hasUtmFields = (): boolean => {
    return UtmStorage.hasFields();
  };

  return {
    getUtmFields,
    setUtmFields,
    clearUtmFields,
    hasUtmFields,
  };
}
